<script lang="ts">
    import { activeToolOptions } from "$lib/state";
    import Options from "$lib/utility/Options.svelte";


    function update(name: string) {
        activeToolOptions.optionChanged(name);
    }
</script>

<!----------------------------------------------------------------------------->

<div>
    {#if $activeToolOptions}
        <Options options={$activeToolOptions} {update} />
    {/if}
</div>

<!----------------------------------------------------------------------------->

<style>
    div {
        padding: 0.5em;
    }
</style>
